module.exports = __webpack_public_path__ + "static/media/inspo.6899c62f.jpg";